import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import CheckIcon from "@mui/icons-material/Check";
import QuizOutlinedIcon from "@mui/icons-material/QuizOutlined";
import { Box } from "@mui/material";
import {
  CONST_PROJECT_TIMELINE_CATEGORY_ICONS,
  CONST_PROJECT_TIMELINE_COLORS,
} from "../../../../constants/lists";
import {
  DATE_FORMATS,
  formatDate,
} from "../../../../services/date-and-time.utils";

const TIMELINE_ICON_SIZE = 22;
const TIMELINE_ICON_FONT_SIZE = 13;

function StepIconCircle({
  bgcolor,
  border,
  color,
  children,
}: {
  bgcolor?: string;
  border?: string;
  color?: string;
  children;
}) {
  return (
    <Box
      width={TIMELINE_ICON_SIZE}
      height={TIMELINE_ICON_SIZE}
      borderRadius="50%"
      bgcolor={bgcolor ?? "#FFFFFF"}
      border={border}
      color={color}
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexShrink={0}
    >
      {children}
    </Box>
  );
}

function TimelineStepIcon({ category, isCompleted, isActive, isError }) {
  const CategoryIcon =
    CONST_PROJECT_TIMELINE_CATEGORY_ICONS[category] ?? QuizOutlinedIcon;
  const iconSx = { fontSize: TIMELINE_ICON_FONT_SIZE };

  if (isCompleted) {
    return (
      <StepIconCircle
        bgcolor={CONST_PROJECT_TIMELINE_COLORS.completed.bg}
        color="#FFFFFF"
      >
        <CheckIcon sx={iconSx} />
      </StepIconCircle>
    );
  }

  if (isError) {
    return (
      <StepIconCircle
        bgcolor={CONST_PROJECT_TIMELINE_COLORS.error.bg}
        color="#FFFFFF"
      >
        <CancelOutlinedIcon sx={iconSx} />
      </StepIconCircle>
    );
  }

  if (isActive) {
    return (
      <StepIconCircle
        bgcolor={CONST_PROJECT_TIMELINE_COLORS.active.bg}
        color="#FFFFFF"
      >
        <CategoryIcon sx={iconSx} />
      </StepIconCircle>
    );
  }

  return (
    <StepIconCircle
      border={`2px solid ${CONST_PROJECT_TIMELINE_COLORS.pending.border}`}
    >
      <CategoryIcon
        sx={{ ...iconSx, color: CONST_PROJECT_TIMELINE_COLORS.pending.icon }}
      />
    </StepIconCircle>
  );
}

function getStepLabelColor(isError, isCompleted, isActive) {
  if (isError) return CONST_PROJECT_TIMELINE_COLORS.error.label;
  if (isCompleted) return CONST_PROJECT_TIMELINE_COLORS.completed.label;
  if (isActive) return CONST_PROJECT_TIMELINE_COLORS.active.label;
  return CONST_PROJECT_TIMELINE_COLORS.pending.label;
}

function formatSelectedTimeSlot(selectedTimeSlot?: {
  from?: string;
  to?: string;
}) {
  if (!selectedTimeSlot?.from) return null;

  const date = formatDate(
    selectedTimeSlot.from,
    DATE_FORMATS.fullDateWithDayWithoutDay
  );
  const time = selectedTimeSlot.to
    ? `${formatDate(
        selectedTimeSlot.from,
        DATE_FORMATS.hourMinWithAMPM
      )} – ${formatDate(selectedTimeSlot.to, DATE_FORMATS.hourMinWithAMPM)}`
    : formatDate(selectedTimeSlot.from, DATE_FORMATS.hourMinWithAMPM);

  return `${date} · ${time}`;
}

export {
  formatSelectedTimeSlot,
  getStepLabelColor,
  TimelineStepIcon,
};
